<script setup lang="ts">
  import type { PropType } from 'vue';
  import { DocumentType } from '$types';

  defineOptions({
    inheritAttrs: false,
  });

  type OrderDocument = {
    id: number;
    type: DocumentType;
    reference_number: string;
    download: string;
  }

  defineProps({
    order: { type: Object, required: true },
    repayment: { type: String, required: false },
    documents: { type: Array as PropType<OrderDocument[]>, required: false, default: [] },
    packages: { type: Array, required: false, default: [] },
  });
</script>
<template>
  <div class="order">
    <OrderDetailsView v-bind="$props" />
  </div>
</template>
